import { render } from "./ProfileCenter.vue?vue&type=template&id=2723680a"
import script from "./ProfileCenter.vue?vue&type=script&lang=js"
export * from "./ProfileCenter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__